/* Desktop menu preview images: always a cross-fade.
   - the three collection images cycle by themselves (attribute driven, so every change fades)
   - a short, deliberate hover on any link with data-dr-img shows its image, then the cycle carries on */
(() => {
  const DWELL = 260;
  const CYCLE_MS = 6000;
  const CYCLE = ['1', '2', '3'];
  const SEL = '#menu_mobile a[data-dr-img]';
  const menu = () => document.getElementById('menu_mobile');
  let dwell = null;
  let cycle = null;
  let hovering = false;
  let idx = 0;

  const show = (v) => { const m = menu(); if (m) m.setAttribute('data-dr-hover', v); };
  const stop = () => { clearInterval(cycle); cycle = null; };
  const start = () => {
    stop();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    cycle = setInterval(() => {
      if (hovering) return;
      const m = menu();
      if (m && (m.dataset.drSub || Date.now() - Number(m.dataset.drSwipe || 0) < 7000)) return;
      const cur = CYCLE.indexOf(m ? m.getAttribute('data-dr-hover') : '');
      idx = ((cur < 0 ? idx : cur) + 1) % CYCLE.length;
      show(CYCLE[idx]);
    }, CYCLE_MS);
  };

  const watch = () => {
    const m = menu();
    if (!m || m.dataset.drHoverReady) return;
    m.dataset.drHoverReady = '1';
    new MutationObserver(() => {
      if (m.open) { idx = 0; hovering = false; show(CYCLE[0]); start(); }
      else { stop(); clearTimeout(dwell); m.removeAttribute('data-dr-hover'); delete m.dataset.drSub; }
    }).observe(m, { attributes: true, attributeFilter: ['open'] });
    if (m.open) { show(CYCLE[0]); start(); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  document.addEventListener('mouseover', (e) => {
    const m = menu();
    if (!m || !e.target.closest) return;
    const link = e.target.closest(SEL);
    if (!link) return;
    hovering = true;
    clearTimeout(dwell);
    dwell = setTimeout(() => show(link.getAttribute('data-dr-img')), DWELL);
  });
  document.addEventListener('mouseout', (e) => {
    const m = menu();
    if (!m || !e.target.closest || !e.target.closest(SEL)) return;
    clearTimeout(dwell);
    if (!e.relatedTarget || !e.relatedTarget.closest || !e.relatedTarget.closest(SEL)) {
      dwell = setTimeout(() => { hovering = false; }, 900);
    }
  });

  /* phones: swipe the photo band to change the picture */
  const band = () => document.querySelector('#menu_mobile .dr-menu__imgs');
  const dots = () => {
    const b = band();
    if (!b || b.querySelector('.dr-menu__dots')) return;
    const d = document.createElement('div');
    d.className = 'dr-menu__dots';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML = CYCLE.map((c) => '<i data-d="' + c + '"></i>').join('');
    b.appendChild(d);
  };
  let sx = 0, sy = 0, moved = false, tracking = false;
  document.addEventListener('touchstart', (e) => {
    tracking = !!(e.target.closest && e.target.closest('#menu_mobile .dr-menu__imgs'));
    if (!tracking) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false;
  }, { passive: true });
  const endSwipe = (e) => {
    if (!tracking) return;
    tracking = false;
    const t = e.changedTouches[0];
    const dx = t.clientX - sx;
    if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(t.clientY - sy) * 1.2) return;
    const m = menu();
    if (!m) return;
    const cur = Math.max(0, CYCLE.indexOf(m.getAttribute('data-dr-hover')));
    idx = (cur + (dx < 0 ? 1 : CYCLE.length - 1)) % CYCLE.length;
    m.dataset.drSwipe = String(Date.now());
    delete m.dataset.drSub;
    show(CYCLE[idx]);
    start();
    moved = true;
  };
  document.addEventListener('touchend', endSwipe, { passive: true });
  document.addEventListener('touchcancel', () => { tracking = false; }, { passive: true });
  document.addEventListener('click', (e) => {
    if (moved && e.target.closest && e.target.closest('#menu_mobile .dr-menu__imgs')) { e.preventDefault(); e.stopPropagation(); }
    moved = false;
  }, true);
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('[aria-controls="menu_mobile"]')) dots(); }, true);
  dots();

  /* phones: drill-down inside the menu (main points -> sub points -> back) */
  document.addEventListener('click', (e) => {
    const m = menu();
    if (!m || !e.target.closest) return;
    const more = e.target.closest('#menu_mobile .dr-menu__more');
    const back = e.target.closest('#menu_mobile .dr-menu__back');
    if (!more && !back) return;
    const inner = m.querySelector('.dr-dialog-drawer__inner');
    if (m.dataset.drLeave) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const swap = () => {
      if (more) {
        m.dataset.drSub = more.dataset.sub;
        show(more.dataset.sub === 'secondary' ? '4' : '7');
      } else {
        delete m.dataset.drSub;
        idx = 0;
        show(CYCLE[0]);
        start();
      }
      if (inner) inner.scrollTop = 0;
      delete m.dataset.drLeave;
      m.dataset.drEnter = more ? 'fwd' : 'back';
      setTimeout(() => { delete m.dataset.drEnter; }, 600);
    };
    if (reduce) { swap(); return; }
    m.dataset.drLeave = more ? 'fwd' : 'back';
    setTimeout(swap, 150);
    return;
  });

  /* phones: account sits in the same row as currency and language */
  const place = () => {
    const m = menu();
    if (!m) return;
    const row = m.querySelector('.dr-mb-language_currencies');
    const acct = m.querySelector('.dr-menu__acct');
    if (row && acct && acct.parentElement !== row) row.insertBefore(acct, row.firstChild);
  };
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('[aria-controls="menu_mobile"]')) place(); }, true);
  place();
})();
